export default "__VITE_ASSET__CX$Z97FR__"